import React from "react";
import { motion } from "framer-motion";

const ProjectsSection = () => {
  const projects = [
    {
      id: 1,
      title: "OwnBills Billing System",
      description:
        "Full-stack platform to digitize electricity readings and automate monthly billing for rental homes.",
      techStack: [
        'MERN Stack',
        'Tailwind CSS',
        'bcrypt.js',
        'CORS',
        'react-hot-toast',
        'Material UI',
        'JWT',
        'Nodemailer',
        'Axios',
      ],
      githubUrl: "https://github.com/harshaal06/BillSystem", // update if specific repo
      liveUrl: "https://ownbills.vercel.app",
      hasLiveDemo: true,
    },
    {
      id: 2,
      title: "ExpenseEase Tracker App",
      description:
        "Secure expense tracker with budgeting, real-time updates, and OTP-based authentication.",
      techStack: [
        'MERN Stack',
        'Tailwind CSS',
        'bcrypt.js',
        'react-icons',
        'JWT',
        'Nodemailer',
        'react-hot-toast',
        "...and more"
      ],
      githubUrl: "https://github.com/harshaal06/ExpenseTracker",
      liveUrl: "https://expense-ease-app-harshal.vercel.app",
      hasLiveDemo: true,
    },
    {
      id: 3,
      title: "Flight Reservation System",
      description:
        "Console-based Java application for flight search, booking, and reservation management.",
      techStack: ["Java", "OOP", "Java Collections", "ArrayList"],
      githubUrl: "https://github.com/harshaal06/Flight-Reservation-System", // update if specific repo
      liveUrl: null,
      hasLiveDemo: false,
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <section
      id="projects"
      className="section-padding 
      bg-white dark:bg-gray-900 
      transition-colors duration-300"
    >
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-12"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-2 text-gray-900 dark:text-gray-100">
            <span className="text-teal-700 dark:text-accent">03.</span> Projects
          </h2>
          <div className="w-32 h-0.5 bg-teal-700 dark:bg-accent mb-8"></div>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {projects.map((project, index) => (
            <motion.div
              key={project.id}
              variants={cardVariants}
              whileHover={{ y: -6 }}
              className="
    relative group
    bg-gray-100/60 dark:bg-gray-800/60
    backdrop-blur-lg
    rounded-2xl
    p-6
    border border-gray-300 dark:border-gray-700
    hover:border-teal-700 dark:hover:border-accent
    transition-all duration-500
    overflow-hidden
  "
            >
              {/* Left Accent Line */}
              <div
                className="
      absolute left-0 top-0 h-full w-1
      bg-teal-700 dark:bg-accent
      scale-y-0 group-hover:scale-y-100
      transition-transform duration-500 origin-top
    "
              ></div>

              {/* Project Number */}
              <div className="absolute top-4 right-4 text-5xl font-bold opacity-10 text-teal-700 dark:text-accent">
                0{index + 1}
              </div>

              {/* Title */}
              <h3 className="text-xl w-[90%] md:text-2xl font-bold mb-2 text-gray-900 dark:text-gray-100">
                {project.title}
              </h3>

              {/* Description */}
              <p className="text-gray-700 dark:text-gray-400 text-sm mb-4 leading-relaxed">
                {project.description}
              </p>

              {/* Tech Stack Inline Modern Style */}
              <div className="flex flex-wrap gap-2 mb-6">
                {project.techStack.map((tech, i) => (
                  <span
                    key={i}
                    className="
          text-xs px-2 md:px-3 py-0.5 md:py-1 rounded-full
          bg-teal-700/10 dark:bg-accent/10
          text-teal-700 dark:text-accent
          border border-teal-700/30 dark:border-accent/30
        "
                  >
                    {tech}
                  </span>
                ))}
              </div>

              {/* Buttons */}
              <div className="flex gap-4">
                {project.hasLiveDemo && project.liveUrl && (
                  <a
                    href={project.liveUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="
          text-sm font-semibold
          text-teal-700 dark:text-accent
          hover:underline
        "
                  >
                    → Live Demo
                  </a>
                )}

                <a
                  href={project.githubUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="
        text-sm font-semibold
        text-gray-800 dark:text-gray-300
        hover:text-teal-700 dark:hover:text-accent
        transition-colors duration-300
      "
                >
                  → View Code
                </a>
              </div>
            </motion.div>
          ))}
        </motion.div>
        {/* More Projects Button */}
<motion.div
  initial={{ opacity: 0, y: 20 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true }}
  transition={{ duration: 0.5 }}
  className="mt-12 text-center"
>
  <a
    href="https://github.com/harshaal06"
    target="_blank"
    rel="noopener noreferrer"
    className="
      inline-flex items-center gap-2
      px-6 py-2
      text-xs md:text-sm font-semibold
      text-teal-700 dark:text-accent
      border border-teal-700/40 dark:border-accent/40
      rounded-full
      hover:bg-teal-700 hover:text-white
      dark:hover:bg-accent dark:hover:text-gray-900
      transition-all duration-300
    "
  >
    View More Projects →
  </a>
</motion.div>

      </div>
    </section>
  );
};

export default ProjectsSection;
